import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
import { Leadgeneration } from "../leads/Leadgeneration";
// Affiliate API not ready yet — reuse the Verkoop (leads) page + data for now.
// Title changed to "Affiliate" and the top action buttons are hidden.
export const Affiliate = () => {
    const { t: translate } = useTranslation();
    return _jsx(Leadgeneration, { title: translate("Affiliate"), hideActions: true, isAffiliate: true });
};
